<!--公用组件：蓝湖app分享组件，一个可以选择分享到不同平台的弹出层
    @dengli
    @date 2018.10.30
    调用示例：
        - <share :show="shareShow" @close="shareShow = false" :protoData="protoData" type="proto" :homeId="homeId" />
    props：
        - show  用于控制组件显示和隐藏
        - close监听组件关闭操作
        - protoData 需要分享的原型数据，设计图分享和原型一致只是不显示原型热区
        - homeId    用于原型分享的主页跳转
        - type  分享的类型（设计图|原型）
-->
<template>
    <div class="share_wrap" v-if="show">
        <div class="mask" @click="close"></div>
        <div class="share_content">
            <div class="share_title">分享给小伙伴获取反馈吧～</div>
            <ul class="share_btns clearfix">
                <li class="wx-friends" @click="share('wxfriends')">
                    <img src="~@/assets/imgs/share/share_wx.png" />
                    <div class="text">微信好友</div>
                </li>
                <li class="wx-moments" @click="share('wxmoments')">
                    <img src="~@/assets/imgs/share/share_wx_friends.png" />
                    <div class="text">朋友圈</div>
                </li>
                <li class="qq-friends" @click="share('qqfriends')">
                    <img src="~@/assets/imgs/share/share_qq.png" />
                    <div class="text">QQ好友</div>
                </li>
                <li class="lanhu-email" @click="share('email')">
                    <img src="~@/assets/imgs/share/share_email.png" />
                    <div class="text">电子邮件</div>
                </li>
                <li class="lanhu-copylink" @click="share('copy')">
                    <img src="~@/assets/imgs/share/share_copy.png" />
                    <div class="text">复制链接</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            default() {
                return false
            }
        },
        protoData: {},
        type: "",
        image: {},
        homeId: ""
    },
    data() {
        return {
            content: "",
            status: ""
        }
    },
    methods: {
        close() {
            localStorage.setItem("bann", "")
            this.$emit("close")
        },
        toWxShare(type, scene) {
            var _this = this
            Wechat.share(
                {
                    message: type,
                    scene: scene
                },
                () => {
                    _this.$root.eventBus.$emit("showTip", "分享成功", "succeed")
                    _this.close()
                },
                reason => {
                    _this.$root.eventBus.$emit("showTip", "请检查您的设备是否安装微信", "normal")
                }
            )
        },
        toQQShare(message) {
            var _this = this
            QQSDK.shareNews(
                () => {
                    _this.$root.eventBus.$emit("showTip", "分享成功", "succeed")
                    _this.close()
                },
                failReason => {
                    _this.$root.eventBus.$emit("showTip", "分享失败", "failed")
                },
                message
            )
        },
        share(way) {
            var _this = this
            if (way === "wxfriends") {
                Wechat.isInstalled(installed => {
                    if (_this.type === "design") {
                        var design = {
                            title: `${_this.image.name} - 设计图分享`,
                            description: `来自${localStorage.teamName}团队${localStorage.name}的分享`,
                            thumb: `${
                                _this.image.src
                            }?x-oss-process=image/resize,m_fill,h_50,w_50&imageView2/1/w/50/h/50`,
                            media: {
                                type: Wechat.Type.WEBPAGE,
                                webpageUrl: `${window.baseURL}/webapp/#/share?id=${_this.image.id}&team_id=${
                                    localStorage.teamId
                                }&type=design`
                            }
                        }
                        _this.toWxShare(design, Wechat.Scene.SESSION)
                    } else if (_this.type === "proto") {
                        var proto = {
                            title: `${_this.protoData.name} - 原型分享`,
                            description: `来自${localStorage.teamName}团队${localStorage.name}的原型分享`,
                            thumb: `${
                                _this.protoData.img
                            }?x-oss-process=image/resize,m_fill,h_50,w_50&imageView2/1/w/50/h/50`,
                            media: {
                                type: Wechat.Type.WEBPAGE,
                                webpageUrl: `${window.baseURL}/webapp/#/share?id=${_this.protoData.id}&team_id=${
                                    _this.protoData.team_id
                                }&home_id=${_this.homeId}&project_name=${encodeURIComponent(localStorage.projectName)}`
                            }
                        }
                        _this.toWxShare(proto, Wechat.Scene.SESSION)
                    }
                })
            }
            if (way === "wxmoments") {
                Wechat.isInstalled(installed => {
                    if (_this.type === "design") {
                        var design = {
                            title: `${_this.image.name} - 设计图分享`,
                            description: `来自${localStorage.teamName}团队${localStorage.name}的分享`,
                            thumb: `${
                                _this.image.src
                            }?x-oss-process=image/resize,m_fill,h_50,w_50&imageView2/1/w/50/h/50`,
                            media: {
                                type: Wechat.Type.WEBPAGE,
                                webpageUrl: `${window.baseURL}/webapp/#/share?id=${_this.image.id}&team_id=${
                                    localStorage.teamId
                                }&type=design`
                            }
                        }
                        _this.toWxShare(design, Wechat.Scene.TIMELINE)
                    } else if (_this.type === "proto") {
                        var proto = {
                            title: `${_this.protoData.name} - 原型分享`,
                            description: `来自${localStorage.teamName}团队${localStorage.name}的原型分享`,
                            thumb: `${
                                _this.protoData.img
                            }?x-oss-process=image/resize,m_fill,h_50,w_50&imageView2/1/w/50/h/50`,
                            media: {
                                type: Wechat.Type.WEBPAGE,
                                webpageUrl: `${window.baseURL}/webapp/#/share?id=${_this.protoData.id}&team_id=${
                                    _this.protoData.team_id
                                }&home_id=${_this.homeId}&project_name=${encodeURIComponent(localStorage.projectName)}`
                            }
                        }
                        _this.toWxShare(proto, Wechat.Scene.TIMELINE)
                    }
                })
            }
            if (way === "qqfriends") {
                QQSDK.checkClientInstalled(
                    () => {
                        if (_this.type === "design") {
                            var designQQ = {
                                client: QQSDK.ClientType.QQ,
                                scene: QQSDK.Scene.QQ,
                                url: `${window.baseURL}/webapp/#/share?id=${_this.image.id}&team_id=${
                                    localStorage.teamId
                                }&type=design`,
                                title: `${_this.image.name} - 设计图分享`,
                                description: `来自${localStorage.teamName}团队${localStorage.name}的分享`,
                                image: `${
                                    _this.image.src
                                }?x-oss-process=image/resize,m_fill,h_50,w_50&imageView2/1/w/50/h/50`
                            }
                            _this.toQQShare(designQQ)
                        } else if (_this.type === "proto") {
                            var protoQQ = {
                                client: QQSDK.ClientType.QQ,
                                scene: QQSDK.Scene.QQ,
                                url: `${window.baseURL}/webapp/#/share?id=${_this.protoData.id}&team_id=${
                                    _this.protoData.team_id
                                }&home_id=${_this.homeId}&project_name=${encodeURIComponent(localStorage.projectName)}`,
                                title: `${_this.protoData.name} - 原型分享`,
                                description: `来自${localStorage.teamName}团队${localStorage.name}的分享`,
                                image: `${
                                    _this.protoData.img
                                }?x-oss-process=image/resize,m_fill,h_50,w_50&imageView2/1/w/50/h/50`
                            }
                            _this.toQQShare(protoQQ)
                        }
                    },
                    err => {
                        _this.$root.eventBus.$emit("showTip", "您的设备未安装QQ", "normal")
                    }
                )
            }
            if (way === "email") {
                if (_this.type === "design") {
                    window.plugins.socialsharing.share(
                        "来自蓝湖的分享",
                        _this.image.name,
                        null,
                        `${window.baseURL}/webapp/#/share?id=${_this.image.id}&team_id=${
                            localStorage.teamId
                        }&type=design`,
                        () => {
                            _this.close()
                        },
                        err => {
                            _this.$root.eventBus.$emit("showTip", "分享失败", "failed")
                            _this.close()
                        }
                    )
                } else if (_this.type === "proto") {
                    window.plugins.socialsharing.share(
                        `${_this.protoData.name} - 原型分享`,
                        "蓝湖",
                        null,
                        `${window.baseURL}/webapp/#/share?id=${_this.protoData.id}&team_id=${
                            _this.protoData.team_id
                        }&home_id=${_this.homeId}&project_name=${encodeURIComponent(localStorage.projectName)}`,
                        () => {
                            _this.$root.eventBus.$emit("showTip", "分享成功", "succeed")
                            _this.close()
                        },
                        err => {
                            _this.$root.eventBus.$emit("showTip", "分享失败", "failed")
                            _this.close()
                        }
                    )
                }
            }
            if (way === "copy") {
                if (_this.type === "design") {
                    cordova.plugins.clipboard.copy(
                        `${window.baseURL}/webapp/#/share?id=${_this.image.id}&team_id=${
                            localStorage.teamId
                        }&type=design`,
                        () => {
                            _this.$root.eventBus.$emit("showTip", "复制成功", "succeed")
                            _this.close()
                        }
                    )
                } else if (_this.type === "proto") {
                    cordova.plugins.clipboard.copy(
                        `${window.baseURL}/webapp/#/share?id=${_this.protoData.id}&team_id=${
                            _this.protoData.team_id
                        }&home_id=${_this.homeId}&project_name=${encodeURIComponent(localStorage.projectName)}`,
                        () => {
                            _this.$root.eventBus.$emit("showTip", "复制成功", "succeed")
                            _this.close()
                        }
                    )
                }
            }
            MtaH5.clickStat("share_design", { [way]: "true" })
        }
    }
}
</script>

<style lang="scss" scoped>
.share_wrap {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1111;
    .mask {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
    }
    .share_content {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 1;
        width: 100%;
        padding-bottom: 1.08rem;
        background: rgba(255, 255, 255, 0.9);
        .share_title {
            color: #888888;
            font-size: 0.7rem;
            padding: 1.08rem 0 1.15rem 0;
            text-align: center;
        }
        .share_btns {
            width: 15.8rem;
            margin: 0 auto;
            li {
                width: 2.7rem;
                float: left;
                margin-right: 0.55rem;
                text-align: center;
                &:last-child {
                    margin-right: 0;
                }
                img {
                    display: block;
                    width: 100%;
                    &:active {
                        filter: brightness(60%);
                    }
                }
                .text {
                    padding-top: 0.55rem;
                    font-size: 0.6rem;
                    color: #888888;
                }
            }
        }
    }
}
</style>
